// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-category-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-category-definitions/aircraft-category-definitions.js';

mount([g0]);
